import { REPEAT } from "../constants/action_types";

export const toggleRepeat = () => async (dispatch) =>
{
  try
  {
    dispatch({ type: REPEAT });
  }
  catch (err)
  {
    console.trace(err);
  }
}
